import React from "react";
import styles from "../resourceMonitoring/ResourceMonitor.module.scss";
import { MiniCalendarSvg, NotFoundIcon } from "../../../modules/default-svg";
import NotFoundLayout from "../../../components/controls/NotFound/NotFound";
import Spin from "../../../components/controls/spinner/Spin";
import { Tooltip } from "@fluentui/react-components";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { getLabelByType } from "../../../helpers/utils";

const AssignedProjectCard = ({ isLoading, projects }) => {
  const history = useHistory();

  return (
    <div
      className={styles.TaskCardContainer}
      style={{ height: projects.length === 0 ? 460 : 560 }}
    >
      <div
        className={
          projects.length > 0
            ? styles.CalendarModalScroll
            : styles.verticallyCenteredContainer
        }
      >
        {isLoading ? (
          <div className={styles.spinnerContainer}>
            <Spin />
          </div>
        ) : (
          <div
            className={`row ${styles.cardBody}`}
            style={{ "--bs-gutter-x": "12px", "--bs-gutter-y": "16px" }}
          >
            {projects.length > 0 ? (
              projects.map((item) => (
                <div
                  className={styles.shiftCardMain}
                  onClick={() =>
                    item?.id
                      ? history.push(`/projects/${item.id}/overview`)
                      : null
                  }
                >
                  <div className="d-flex justify-content-between">
                    <div className={styles.shiftCardHeader}>
                      <h5 className="font-weight-500">{item.name}</h5>

                      <Tooltip
                        content={{
                          children: `Capacity: ${
                            (
                              (item.allocatedCapacity / item.progress) *
                              100
                            )?.toFixed(2) || 0
                          }% Utilized`,
                          className: styles.Navtooltip,
                        }}
                        relationship="label"
                        withArrow
                        positioning="after"
                      >
                        <div className={styles.capacity}>
                          Capacity:{" "}
                          <span className="text-xsm-600 calanderHeadercolor">
                            {item.allocatedCapacity}hrs
                          </span>
                        </div>
                      </Tooltip>
                    </div>
                    <div className={styles.capacity}>
                      Status:{" "}
                      <span className="text-xsm-600 calanderHeadercolor">
                        { getLabelByType("project",item.status)}
                      </span>
                    </div>
                  </div>
                  <div className="d-flex align-items-center gap-2">
                    <div className="d-flex align-items-center gap-1">
                      <MiniCalendarSvg />
                      <span className="text-xsm-400 greyStrokeColor">
                        {item?.startDate?.split("T")[0].split("-").join("/") ||
                          "No Start Date"}{" "}
                        -{" "}
                        {item?.endDate?.split("T")[0].split("-").join("/") ||
                          "No End Date"}
                      </span>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <NotFoundLayout
                icon={<NotFoundIcon />}
                heading="No data currently available!"
                para="Try searching for what you need or explore other features to get
        started."
              />
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default AssignedProjectCard;
